interface TabelaDaListagemProps {
  ariaLabel: string;
  headTable: string[];
  tableBody: any;
  columnWidths?: (number | string)[];
}

export function TabelaDaListagem({
  ariaLabel,
  headTable,
  tableBody,
  columnWidths = [],
}: TabelaDaListagemProps) {
  return (
    <div className="w-full overflow-hidden rounded-xl border border-slate-200 dark:border-slate-700">
      <div className="custom-scrollbar w-full overflow-x-auto">
        <table
          aria-label={ariaLabel}
          className="w-full table-fixed border-collapse"
          style={{ minWidth: 1300 }}
        >
          <thead className="sticky top-0 z-[1] bg-slate-50 dark:bg-slate-800">
            <tr>
              {headTable.map((head, idx) => (
                <th
                  key={idx}
                  style={{ minWidth: columnWidths[idx] || 100 }}
                  className="whitespace-nowrap px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400"
                >
                  {head}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100 bg-white dark:divide-slate-700 dark:bg-slate-800">
            {tableBody}
          </tbody>
        </table>
      </div>
    </div>
  );
}

